export default {
  en: {
    actions: {
      mark_as_read: 'Mark as read',
      mark_as_unread: 'Mark as unread',
      mark_all_as_read: 'Mark all as read',
      settings: 'Notification settings',
      delete: 'Delete',
    },
  },
};
